<div class="app-container">
    <app-header></app-header>
    <div class="main-container" id="main-container-id">
        <app-side-nav></app-side-nav>
        <section class="layout-container p-3" (click)="closeSideNavIfSmallScreen()">
            <router-outlet></router-outlet>
        </section>
    </div>
</div>